import { extractBotStrId } from "./utils/routingUtil";
const botId = extractBotStrId(window.location.href);
export const Urls={
    LOGIN:'/login',
    SIGNUP:"/signup",
    SIGNUPV2:`/signupv2`,
    VERIFY:"/verify",
    ONBOARDING:`/onboarding`,
    FORGOT_PASSSWORD:"/forgot-password",
    HOME:"/home",
    PROFILE:"/profile",
    DASHBOARD:`/${botId}/dashboard`,
    SUBSCRIPTION:`/${botId}/subscription`,
    DOWNLOADS:`/${botId}/downloads`,
    BOT_BUILDER_STORYBUILDER:`/${botId}/bot-builder/story-builder`,
    BOT_BUILDER_ENTITIES:`/${botId}/bot-builder/entities`,
    BOT_BUILDER_FAQS:`/${botId}/bot-builder/faqs`,
    BOT_BUILDER_FUNCTIONS:`/${botId}/bot-builder/functions`,
    BOT_BUILDER_SMALLTALK:`/${botId}/bot-builder/smalltalk`,
    BOT_BUILDER_SURVEYS:`/${botId}/bot-builder/surveys`,
    BOT_BUILDER_DATASET:`/${botId}/bot-builder/dataset`,
    BOT_BUILDER_BOT_LOGS:`/${botId}/bot-builder/logs`,
    BOT_BUILDER_BOTSETTINGS:`/${botId}/bot-builder/bot-settings`,
    BOT_BUILDER_RETRAINING:`/${botId}/bot-builder/retraining`,
    INBOX:`/${botId}/inbox`,
    TICKETS:`/${botId}/tickets`,
    CONTACTS:`/${botId}/contacts`,
    CAMPAIGN:`/${botId}/campaign`,
    CONVERSATION_STARTER:`/${botId}/conversation-starter`,
    RETRAINING:`/${botId}/retraining`,
    USER:`/${botId}/user`,
    SETTINGS:`/${botId}/settings`,
    APP_STORE:`/${botId}/integrations`,
    APP_STORE_ZOHODESK:`/${botId}/integrations/zoho-desk`,
    APP_STORE_HUBSPOT:`/${botId}/integrations/hubspot`,
    APP_STORE_LEADSQUARED:`/${botId}/integrations/leadsquared`,
    APP_STORE_FRESHSALES:`/${botId}/integrations/freshsales`,
    APP_STORE_ZOHOCRM:`/${botId}/integrations/zoho-crm`,
    APP_STORE_PIPEDRIVE:`/${botId}/integrations/pipedrive`,
    APP_STORE_SHOPIFY:`/${botId}/integrations/shopify`,
    APP_STORE_MAGENTO:`/${botId}/integrations/magento`,
    APP_STORE_GOOGLE_SHEETS:`/${botId}/integrations/google-sheets`,
    APP_STORE_FRESHDESK:`/${botId}/integrations/freshdesk`,
    CANNED_RESPONSES:`/${botId}/canned-responses`,
    CHANNELS_WEBAPP_APPEARANCE:`/${botId}/channels/webapp/appearance`,
    CHANNELS_WEBAPP_SCRIPT:`/${botId}/channels/webapp/script`,
    CHANNELS_WEBAPP_DETAILS:`/${botId}/channels/whatsapp/details`,
    CHANNELS_WHATSAPP_TEMPLATES:`/${botId}/channels/whatsapp/templates`,
    CHANNELS_WHATSAPP_KEYS:`/${botId}/channels/whatsapp/keys`,
    CHANNELS_WHATSAPP_SETUP:`/${botId}/channels/whatsapp/setup`,
    CHANNELS_GMB_CONNECT:`/${botId}/channels/gmb/connect`,
    CHANNELS_WABAC_CONNECT:`/${botId}/channels/whatsappcloud/connect`,
    CHANNELS_FACEBOOK_CONNECT:`/${botId}/channels/facebook/connect`,
    CHANNELS_INSTAGRAM_CONNECT:`/${botId}/channels/instagram/connect`,
    CSAT_CONFIG:`/${botId}/csat-configuration`,
    MESSENGER:`/${botId}/messenger`,
    SUBSCRIPTION:`/${botId}/subscription`,
    BUSINESS_HOURS:`/${botId}/business-hours`,
    CHAT_ASSIGNMENT:`/${botId}/chat-assignment`,
    ALERTS:`/${botId}/alerts`,
    SCHEDULES:`/${botId}/schedules`,
    TAGS:`/${botId}/tags`,
    SYSTEM_EVENTS:`/${botId}/system-events`,
    CRM_SCHEMA:`/${botId}/crmschema`,
};
